import { render, staticRenderFns } from "./period-batch-approval-detail.vue?vue&type=template&id=500ce937&scoped=true"
import script from "./period-batch-approval-detail.vue?vue&type=script&lang=js"
export * from "./period-batch-approval-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500ce937",
  null
  
)

export default component.exports